import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from './msal';
import { CreateEventComponent } from './pages/create-event/create-event.component';
import { HistoryComponent } from './pages/history/history.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { EventComponent } from './pages/event/event.component';
import { ConnectionsComponent } from './pages/connections/connections.component';
import { ResolutionsComponent } from './pages/resolutions/resolutions.component';
import { ResolutionOrdersComponent } from './pages/resolution-orders/resolution-orders.component';
import { EventHistoryComponent } from './pages/event-history/event-history.component';
import { ReportsDashboardComponent } from './pages/reports-dashboard/reports-dashboard.component';
import { ReportsOrderInfoComponent } from './pages/reports-order-info/reports-order-info.component';
import { ReportsImportComponent } from './pages/reports-import/reports-import.component';
import { ReportsHistoryComponent } from './pages/reports-history/reports-history.component';
import { ReportsSafetyDashboardComponent } from './pages/reports-safety-dashboard/reports-safety-dashboard.component';
import { ImportFtpFileImportComponent } from './pages/import-ftp-file-import/import-ftp-file-import.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HistoryContentsComponent } from './pages/history/history-contents/history-contents.component';
import { ResolutionBaseComponent } from './pages/resolutions/resolution-base/resolution-base.component';
import { ControlPointMatrixComponent } from './pages/control-point-matrix/control-point-matrix.component';
import { SafetyDashboardComponent } from './pages/safety-dashboard/safety-dashboard.component';
import { SafetyDashboardBaseComponent } from './pages/safety-dashboard/safety-dashboard-base/safety-dashboard-base.component';
import { KpiComponent } from './pages/kpi/kpi.component';
import { DashboardBaseComponent } from './pages/dashboard/dashboard-base/dashboard-base.component';
import { MasterConfigComponent } from './pages/dashboard/master-config/master-config.component';
import { AddEventButtonComponent } from './pages/dashboard/add-event-button/add-event-button.component';
import { AddResolutionComponent } from './core/check/add-resolution/add-resolution.component';
import { AddResolutionOrdersComponent } from './pages/add-resolution-orders/add-resolution-orders.component';
import { AddresolutionordersgridComponent } from './pages/addresolutionordersgrid/addresolutionordersgrid.component';
import { ReportsBorderCrossing } from './pages/reports-border-crossing/reports-border-crossing.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
const path_1 = 'aet reports'
const path_2 = 'Event Details'

const routes: Routes = [
	{ path: 'unauthorized', component: UnauthorizedComponent},
	{ path: 'safety-dashboard', component: SafetyDashboardBaseComponent, data: { breadcrumb: 'AET SAFETY' },
		children: [
			{ path: '', component: SafetyDashboardComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
			{ path: 'create-event', component: CreateEventComponent, data: { breadcrumb: 'Create Event' }, canActivate: [MsalGuard]  },
		], canActivate: [MsalGuard]
	},
	{ path: 'dashboard', component: DashboardBaseComponent, data: { breadcrumb: 'Dashboard' },
    children: [
      { path: '', component: DashboardComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
      { path: 'addEvent',component: AddEventButtonComponent,data: { breadcrumb: 'Add Event' }, canActivate: [MsalGuard] },
      { path: 'master-config', component: MasterConfigComponent, data: { breadcrumb: 'Master Config' }, canActivate: [MsalGuard]  },
      { path: 'event', component: EventComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard]  },
			{
				path: 'resolutions', component: ResolutionBaseComponent, data: { breadcrumb: path_2 },
				children: [
					{ path: '', component: ResolutionsComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard]  },
					{ path: 'add-resolution-orders', component: AddResolutionOrdersComponent, data: { breadcrumb: 'Add Resolution Orders' }, canActivate: [MsalGuard] },
	                { path: 'add-resolution-orders-grid', component: AddresolutionordersgridComponent, canActivate: [MsalGuard] },
					{ path: 'add-resolution', component: AddResolutionComponent, data: { breadcrumb: 'Add Resolution' }, canActivate: [MsalGuard] },
				], canActivate: [MsalGuard]
			},
			{ path: 'connections', component: ConnectionsComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard] },
			{ path: 'event-history', component: EventHistoryComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard] },
    ], canActivate: [MsalGuard]
  },
  { path: 'import', component: ImportFtpFileImportComponent, data: { breadcrumb: 'AET Imports' }, canActivate: [MsalGuard] },
	{
		path: 'history', component: HistoryComponent, data: { breadcrumb: 'history' },
		children: [
			{ path: '', component: HistoryContentsComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard]  },
			{ path: 'event', component: EventComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard]  },
			{
				path: 'resolutions', component: ResolutionBaseComponent, data: { breadcrumb: path_2 },
				children: [
					{ path: '', component: ResolutionsComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard]  },
					{ path: 'resolution-orders', component: ResolutionOrdersComponent, data: { breadcrumb: 'Resolution Orders' }, canActivate: [MsalGuard] },
				], canActivate: [MsalGuard]
			},
			{ path: 'connections', component: ConnectionsComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard] },
			{ path: 'event-history', component: EventHistoryComponent, data: { breadcrumb: path_2 }, canActivate: [MsalGuard] },
		], canActivate: [MsalGuard]
	},

	{ path: 'cpMatrix', component: ControlPointMatrixComponent, data: { breadcrumb: 'Control Point Matrix' }, canActivate: [MsalGuard] },
	{ path: 'kpi', component: KpiComponent, data: { breadcrumb: 'aet kpi' }, canActivate: [MsalGuard] },
	{ path: 'event-details', component: EventDetailsComponent, canActivate: [MsalGuard]  },
	{ path: 'reports-dashboard', component: ReportsDashboardComponent, data: { breadcrumb: path_1 }, canActivate: [MsalGuard] },
	{ path: 'reports-history', component: ReportsHistoryComponent, data: { breadcrumb: path_1 }, canActivate: [MsalGuard]  },
	{ path: 'reports-import', component: ReportsImportComponent, data: { breadcrumb: path_1 }, canActivate: [MsalGuard]  },
	{ path: 'reports-order-info', component: ReportsOrderInfoComponent, data: { breadcrumb: path_1 }, canActivate: [MsalGuard]  },
	{ path: 'reports-safety-dashboard', component: ReportsSafetyDashboardComponent, data: { breadcrumb: path_1 }, canActivate: [MsalGuard]  },
  { path: 'reports-border-crossing', component: ReportsBorderCrossing, data: { breadcrumb: path_1 }, canActivate: [MsalGuard]  },
  { path: 'notifications', component: NotificationComponent, data: { breadcrumb: 'AET Notifications' },  canActivate: [MsalGuard]  },
	{ path: '**', redirectTo:'/dashboard', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
